import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";

const ModalEdit = ({ treinamento, fecharModal, atualizarLista }) => {

    const api = useApi();

    console.log(treinamento);

    const [ loading, setLoading ] = useState( false );

    const [novaData, setNovaData] = useState(treinamento.mes_ano);

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        setLoading( true );

        try{

            const formData = new FormData();
            formData.append('id', treinamento.id);
            formData.append('nova_data', novaData);

            await api.post('/Painel/API/Treinamentos/EditProgram/', formData );

            fecharModal();
            atualizarLista();

        }catch( e ){

            console.log( e )

        }finally{

            setLoading( false );

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fecharModal} >
                    <Formulario onSubmit={ handleSubmit } >
                        <FormComp
                            title="COLABORADOR"
                            type="text"
                            readOnly
                            valor={treinamento.colaborador}
                        />
                        <FormComp
                            title="TREINAMENTO"
                            type="text"
                            readOnly
                            valor={treinamento.treinamento}
                        />
                        <FormComp
                            title="MÊS/ANO"
                            type="month"
                            valor={novaData}
                            changeFunc={(e) => setNovaData(e.target.value)}
                        />
                        <FormComp
                            type="submit"
                            valor={ loading ? "CARREGANDO..." : "ATUALIZAR" }
                            disabled={ loading }
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalEdit;